<app-ticket-detail [pageMode]="true" [backHelpPage]="backHelpPage" [backRatingPage]="backRatingPage" [ready]="ready"></app-ticket-detail>